﻿const removeDiacritics = (str: string): string => {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
};

export const createUrlFromQuestion = (
    questionId: number,
    question: string
): string => {
    // Return root path if question is empty or whitespace
    if (!question?.trim()) {
        return '/';
    }

    // Remove diacritical marks
    let processed = removeDiacritics(question);

    // Remove non-ASCII characters (equivalent to C#'s @"[^\u0020-\u007E]")
    processed = processed.replace(/[^\x20-\x7E]/g, '');

    // Trim whitespace and replace special characters
    processed = processed
        .trim()
        .replace(/\s+/g, '-') // Replace spaces with hyphens
        .replace(/\?/g, '') // Remove question marks
        .replace(/\//g, ''); // Remove forward slashes

    // URI encode and convert to lowercase
    processed = encodeURIComponent(processed).toLowerCase();

    // Remove multiple consecutive hyphens
    processed = processed.replace(/-{2,}/g, '-');

    return `/article/${questionId}/${processed}`;
};
